import { combineReducers } from "redux";
import logReducer from "./logger/logReducer";
import dialogReducer from "./dialogs/dialogReducer";
import coursesReducer from "./courses/courseReducer";
import semPeriodReducer from "./sem_periods/semPeriodReducer";
import cartItemsReducer from "./cart/cartReducer";

const rootReducer = combineReducers({
  logger: logReducer,
  dialogReducer: dialogReducer,
  coursesReducer: coursesReducer,
  semPeriodReducer: semPeriodReducer,
  cartReducer: cartItemsReducer,
});

export default rootReducer;
